import { render, staticRenderFns } from "./CorrectEvent.vue?vue&type=template&id=423def46&"
import script from "./CorrectEvent.vue?vue&type=script&lang=js&"
export * from "./CorrectEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports